module.exports = __webpack_public_path__ + "img/footer-pdf.aba0c5e8.jpg";